<template>
  <div class="wbg">
    <a-tree v-model="checkedKeys" checkable :expanded-keys="expandedKeys" :auto-expand-parent="autoExpandParent" :tree-data="treeData" @expand="onExpand" />
  </div>
</template>
<script>
import TreeJson from "./t"

export default {
  data() {
    return {
      expandedKeys: [],
      treeData: TreeJson,
      visible: true,
      checkedKeys: [],
      autoExpandParent: true
    }
  },
  created() {

  },
  methods: {
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false
    },
  }
}
</script>